module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Patch.f5cf9660.webp";